import React from 'react';
import { Margin } from '@upgrade/react-components';
import useWindowMinWidth from '@upgrade/react-components/hooks/useWindowMinWidth';

import { BannerContainer } from './styles';
import Image from '../Image';
import { Text } from '../TypographyPublicSite';

const FlexPayBanner = () => {
  const [isSm] = useWindowMinWidth('sm');
  const imgAttributes = isSm ? { height: '24', width: '96' } : { height: '18', width: '72' };

  return (
    <BannerContainer>
      <Text as="p" bold size="md" marginBottom="xs">
        Uplift is now
        <Margin as="span" left="sm">
          <Image alt="Flex Pay" src="/img/flex-pay-logo-horizontal.svg" {...imgAttributes} />
        </Margin>
      </Text>
      <Text as="p" color="content" size="sm" marginBottom="none">
        We&apos;ll send you an email when it&apos;s time to migrate or merge your account. Until you receive an email,
        continue to make payments{' '}
        <a href="https://pay.uplift.com" aria-label="Make a payment on Uplift.com">
          here
        </a>
        .
      </Text>
    </BannerContainer>
  );
};

export default FlexPayBanner;
